const axios = require('axios');

var getTruongByMaTinh = (matinh) => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUONG}${process.env.VUE_APP_TRUONGBYMATINH}/${matinh}`)
        .then(response => {
            return response
        }).catch(error => {
            return error.response
        });
};

var getTruongById = (truongId) => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUONG}/${truongId}`)
        .then(response => response).catch(error => error.response);
};

var getTinhs = () => {
    return axios.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_TINH}`).
        then(response => response).catch(error => error.response);
}

export const TruongService = {
    getTruongByMaTinh, getTruongById, getTinhs
}